import axios from "../axios";
import h from "../helpers";
import { clientIp } from "../api-address";

const returSupplier = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("retur-supplier"), {
      params: { ...params },
    });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("retur-supplier/" + id));
    return data;
  },
  store: async (
    code,
    supplier_id,
    product_name,
    product_variant_id,
    qty,
    reason,
    status,
  ) => {
    const { data } = await axios.post(h.baseUrl("retur-supplier"), {
      code,
      supplier_id,
      product_name,
      product_variant_id,
      qty,
      reason,
      status,
      ip_address: await clientIp(),
    });
    return data;
  },
  update: async (
    id,
    name,
    code,
    variant_id,
    supplier_id,
    price,
    weight,
    imageUrl
  ) => {
    const { data } = await axios.put(h.baseUrl("retur-supplier/" + id), {
      name,
      code,
      variant_id,
      supplier_id,
      price,
      weight,
      imageUrl,
      ip_address: await clientIp(),
    });
    return data;
  },
  delete: async (id) => {
    const ip = await clientIp();
    const { data } = await axios.delete(
      h.baseUrl("retur-supplier/" + id + `?ip_address=${ip}`)
    );
    return data;
  },
};

export default returSupplier;
